var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"logout-btn"},on:{"click":function($event){_vm.logout(_vm.$store.getters.StateUser.user.user_type.includes('institute_admin') ||
 _vm.$store.getters.StateUser.user.user_type.includes('operator'))}}},[_vm._v(_vm._s(_vm.$t("header.logout")))])}
var staticRenderFns = []

export { render, staticRenderFns }